/* eslint-disable @typescript-eslint/explicit-function-return-type */
const elementPrefix = 'web-';
const eventPrefix = 'on-';
module.exports = { elementPrefix, eventPrefix };
